const topics = [
  { label: '暗夜追踪', count: '12.8万', hot: true },
  { label: '午夜剧场', count: '10.5万', hot: true },
  { label: '悬疑烧脑', count: '9.3万', hot: false },
  { label: '科幻巨制', count: '8.7万', hot: true },
  { label: '深夜美食', count: '7.2万', hot: false },
  { label: '追剧不眠', count: '11.6万', hot: true },
  { label: '经典老片', count: '6.8万', hot: false },
  { label: '熬夜看剧', count: '13.1万', hot: true },
  { label: '秒播高清', count: '5.9万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            夜猫子们今晚在讨论什么热门影视话题
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <div
                key={i}
                className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 ${
                  topic.hot
                    ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 hover:border-primary-300'
                    : 'bg-background-100 border-background-200/70 hover:bg-background-200 hover:border-background-300'
                }`}
              >
                {topic.hot && (
                  <i className="ri-fire-fill text-accent-500 text-xs"></i>
                )}
                <span className={`text-sm font-medium ${topic.hot ? 'text-foreground-900' : 'text-foreground-600'}`}>
                  #{topic.label}
                </span>
                <span className="text-xs text-foreground-400">{topic.count}</span>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-foreground-400">
              话题热度实时更新，数据统计基于最近 7 天夜间时段（22:00 - 06:00）的观影互动
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}